module.exports = __webpack_public_path__ + "static/media/logo-new-dark.a056084d.svg";